import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceExportedBatchesItemsList from './InsuranceExportedBatchesItemsList';
import { InsuranceReportBatch } from '../../../../graphql/graphql';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	items: InsuranceReportBatch[];
	onReload: () => void;
}

const InsuranceExportedBatchesItemsListModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.insuranceExportedBatchesItemsList.modalTitle'
			size={Size.FULLSCREEN}>
			<InsuranceExportedBatchesItemsList
				items={props.items}
				onReload={props.onReload}
			/>
		</BaseModal>
	);
};

export default InsuranceExportedBatchesItemsListModal;
